export default {
  webApiUrl: process.env.API_URL,
  authUrl: process.env.AUTH_API_URL,
};
